import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function CreditNoteList() {
  const { user } = useUser()
  let view = contentLayout[modules.CreditNoteList]
  if (user.permissions.views.length && !user.permissions.views.join().includes(modules.CreditNoteList.toLowerCase())) {
    view = Forbidden
  }
  return (
    <Index content={view} module={modules.CreditNoteList}></Index>
  )
}

export default CreditNoteList
